module.exports = __webpack_public_path__ + "static/img/contact-map-marker.d45c28b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/contact-map-marker.png
// module id = 89
// module chunks = 0